import {
    PARTNER_AGENT_LIST_REQUEST,
    PARTNER_AGENT_LIST_SUCCESS,
    PARTNER_AGENT_LIST_FAIL,
    PARTNER_AGENT_LIST_RESET,
    PARTNER_AGENT_CREATE_REQUEST,
    PARTNER_AGENT_CREATE_SUCCESS,
    PARTNER_AGENT_CREATE_FAIL,
    PARTNER_AGENT_GET_REQUEST,
    PARTNER_AGENT_GET_SUCCESS,
    PARTNER_AGENT_GET_FAIL,
    PARTNER_AGENT_UPDATE_SUCCESS,
    PARTNER_AGENT_UPDATE_REQUEST,
    PARTNER_AGENT_UPDATE_FAIL,
    PARTNER_AGENT_DELETE_REQUEST,
    PARTNER_AGENT_DELETE_SUCCESS,
    PARTNER_AGENT_DELETE_FAIL,
    PARTNER_AGENT_CREATE_RESET,
    PARTNER_AGENT_UPDATE_RESET,
    PARTNER_AGENT_GET_RESET
} from '../constants/partnerAgentConstants'

export const partnerAgentListReducer = (state = { partneragents: [] }, action) => {
    switch (action.type) {
        case PARTNER_AGENT_LIST_REQUEST:
            return { loading: true };
        case PARTNER_AGENT_LIST_SUCCESS:
            return { loading: false, partneragents: action.payload }
        case PARTNER_AGENT_LIST_FAIL:
            return { loading: false, error: action.payload }
        case PARTNER_AGENT_LIST_RESET:
            return { loading: false, partneragents: [] }
        default:
            return state;
    }
}

export const partnerAgentCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case PARTNER_AGENT_CREATE_REQUEST:
            return { loading: true };
        case PARTNER_AGENT_CREATE_SUCCESS:
            return { loading: false, success: action.payload }
        case PARTNER_AGENT_CREATE_FAIL:
            return { loading: false, error: action.payload }
        case PARTNER_AGENT_CREATE_RESET:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}

export const partnerAgentDetailsReducer = (state = { partneragent: [] }, action) => {
    switch (action.type) {
        case PARTNER_AGENT_GET_REQUEST:
            return { loading: true };
        case PARTNER_AGENT_GET_SUCCESS:
            return { loading: false, partneragent: action.payload }
        case PARTNER_AGENT_GET_FAIL:
            return { loading: false, error: action.payload }
        case PARTNER_AGENT_GET_RESET:
            return { loading: false, partneragent: [] }
        default:
            return state;
    }
}

export const partnerAgentUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case PARTNER_AGENT_UPDATE_REQUEST:
            return { loading: true };
        case PARTNER_AGENT_UPDATE_SUCCESS:
            return { loading: false, success: action.payload }
        case PARTNER_AGENT_UPDATE_FAIL:
            return { loading: false, error: action.payload }
        case PARTNER_AGENT_UPDATE_RESET:
            return { loading: false, success: '' }
        default:
            return state;
    }
}

export const partnerAgentDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case PARTNER_AGENT_DELETE_REQUEST:
            return { loading: true };
        case PARTNER_AGENT_DELETE_SUCCESS:
            return { loading: false, success: action.payload }
        case PARTNER_AGENT_DELETE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}

